import * as S from '@effect/schema/Schema';
import { Effect } from 'effect';
import { ClientInformation } from '../services/clientInformation';
export const Tenant = S.Struct({
    id: S.String,
    displayName: S.String,
});
export const Tenants = S.Array(Tenant);
export const parseTenants = S.decodeUnknown(Tenants);
export const getTenants = Effect.gen(function* (_) {
    const clientInfoService = yield* _(ClientInformation);
    const { data } = yield* _(clientInfoService.getTenants());
    return yield* _(parseTenants(data));
});
